/**
 * Avatar initials and display-label tokens, in every app (ADR-0088 D2).
 * One rule, so the same person never shows different initials per page:
 * each app passes the label it shows (the learner app, the first name).
 */
/** Two-character initials: the first letters of the first two tokens, or
 * the first two letters of a single token; "?" for an empty label, so an
 * avatar that always renders has something to show. */
export function initialsFromName(name) {
    const trimmed = name?.trim();
    if (!trimmed)
        return '?';
    const tokens = trimmed.split(/\s+/);
    if (tokens.length >= 2) {
        return ((tokens[0]?.[0] ?? '') + (tokens[1]?.[0] ?? '')).toUpperCase() || '?';
    }
    return trimmed.slice(0, 2).toUpperCase();
}
/** The first whitespace-separated token of a display label. A string
 * utility: it does not infer formal identity. */
export function firstTokenOf(name) {
    return name?.trim().split(/\s+/)[0] ?? '';
}
/** Everything after a display label's first token. Not a family-name
 * parser: formal identity uses explicit first and last fields. */
export function restTokensOf(name) {
    const trimmed = name?.trim();
    if (!trimmed)
        return '';
    return trimmed.split(/\s+/).slice(1).join(' ');
}
//# sourceMappingURL=initials.js.map